export default __webpack_public_path__ + "static/media/mitsuha-smile.0fe47392.gif";